import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainDefaultsQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainDefaultsQuery = { __typename?: 'Query', domainDefaults: { __typename?: 'DomainDefaultsInfo', language?: string | null, vendor: { __typename?: 'DefaultVendor', id: number, name: string }, deviceVariant?: { __typename?: 'DefaultDeviceVariant', id: number, name: string } | null } };

export type DomainDefaultsDataSourceQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainDefaultsDataSourceQuery = { __typename?: 'Query', vendors?: Array<{ __typename?: 'Vendor', id: number, name: string } | null> | null, deviceVariants?: { __typename?: 'DeviceVariantList', items: Array<{ __typename?: 'DeviceVariant', id: number, name: string } | null> } | null };

export type DomainDefaultsUpdateMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  vendorId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  deviceVariantId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  language?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type DomainDefaultsUpdateMutation = { __typename?: 'Mutation', domainDefaultsUpdate: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } };


export const DomainDefaultsDocument = gql`
    query DomainDefaults($domainId: Int!) {
  domainDefaults(domainId: $domainId) {
    vendor {
      id
      name
    }
    deviceVariant {
      id
      name
    }
    language
  }
}
    `;

/**
 * __useDomainDefaultsQuery__
 *
 * To run a query within a React component, call `useDomainDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainDefaultsQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainDefaultsQuery(baseOptions: Apollo.QueryHookOptions<DomainDefaultsQuery, DomainDefaultsQueryVariables> & ({ variables: DomainDefaultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainDefaultsQuery, DomainDefaultsQueryVariables>(DomainDefaultsDocument, options);
      }
export function useDomainDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainDefaultsQuery, DomainDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainDefaultsQuery, DomainDefaultsQueryVariables>(DomainDefaultsDocument, options);
        }
export function useDomainDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainDefaultsQuery, DomainDefaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainDefaultsQuery, DomainDefaultsQueryVariables>(DomainDefaultsDocument, options);
        }
export type DomainDefaultsQueryHookResult = ReturnType<typeof useDomainDefaultsQuery>;
export type DomainDefaultsLazyQueryHookResult = ReturnType<typeof useDomainDefaultsLazyQuery>;
export type DomainDefaultsSuspenseQueryHookResult = ReturnType<typeof useDomainDefaultsSuspenseQuery>;
export type DomainDefaultsQueryResult = Apollo.QueryResult<DomainDefaultsQuery, DomainDefaultsQueryVariables>;
export const DomainDefaultsDataSourceDocument = gql`
    query DomainDefaultsDataSource($domainId: Int!) {
  vendors {
    id
    name
  }
  deviceVariants(domainIdOrNone: $domainId) {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useDomainDefaultsDataSourceQuery__
 *
 * To run a query within a React component, call `useDomainDefaultsDataSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainDefaultsDataSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainDefaultsDataSourceQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainDefaultsDataSourceQuery(baseOptions: Apollo.QueryHookOptions<DomainDefaultsDataSourceQuery, DomainDefaultsDataSourceQueryVariables> & ({ variables: DomainDefaultsDataSourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainDefaultsDataSourceQuery, DomainDefaultsDataSourceQueryVariables>(DomainDefaultsDataSourceDocument, options);
      }
export function useDomainDefaultsDataSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainDefaultsDataSourceQuery, DomainDefaultsDataSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainDefaultsDataSourceQuery, DomainDefaultsDataSourceQueryVariables>(DomainDefaultsDataSourceDocument, options);
        }
export function useDomainDefaultsDataSourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainDefaultsDataSourceQuery, DomainDefaultsDataSourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainDefaultsDataSourceQuery, DomainDefaultsDataSourceQueryVariables>(DomainDefaultsDataSourceDocument, options);
        }
export type DomainDefaultsDataSourceQueryHookResult = ReturnType<typeof useDomainDefaultsDataSourceQuery>;
export type DomainDefaultsDataSourceLazyQueryHookResult = ReturnType<typeof useDomainDefaultsDataSourceLazyQuery>;
export type DomainDefaultsDataSourceSuspenseQueryHookResult = ReturnType<typeof useDomainDefaultsDataSourceSuspenseQuery>;
export type DomainDefaultsDataSourceQueryResult = Apollo.QueryResult<DomainDefaultsDataSourceQuery, DomainDefaultsDataSourceQueryVariables>;
export const DomainDefaultsUpdateDocument = gql`
    mutation DomainDefaultsUpdate($domainId: Int!, $vendorId: Int, $deviceVariantId: Int, $language: String) {
  domainDefaultsUpdate(
    domainId: $domainId
    vendorId: $vendorId
    deviceVariantId: $deviceVariantId
    language: $language
  ) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type DomainDefaultsUpdateMutationFn = Apollo.MutationFunction<DomainDefaultsUpdateMutation, DomainDefaultsUpdateMutationVariables>;

/**
 * __useDomainDefaultsUpdateMutation__
 *
 * To run a mutation, you first call `useDomainDefaultsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainDefaultsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainDefaultsUpdateMutation, { data, loading, error }] = useDomainDefaultsUpdateMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      vendorId: // value for 'vendorId'
 *      deviceVariantId: // value for 'deviceVariantId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useDomainDefaultsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DomainDefaultsUpdateMutation, DomainDefaultsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainDefaultsUpdateMutation, DomainDefaultsUpdateMutationVariables>(DomainDefaultsUpdateDocument, options);
      }
export type DomainDefaultsUpdateMutationHookResult = ReturnType<typeof useDomainDefaultsUpdateMutation>;
export type DomainDefaultsUpdateMutationResult = Apollo.MutationResult<DomainDefaultsUpdateMutation>;
export type DomainDefaultsUpdateMutationOptions = Apollo.BaseMutationOptions<DomainDefaultsUpdateMutation, DomainDefaultsUpdateMutationVariables>;